import { onClick } from "@/libs/dom.js";

export default function () {
	onClick("button.fullscreen", () => {
		window.gameInstance.SetFullscreen(1);
	});
}
